// extracted by mini-css-extract-plugin
var _1 = "SectionChangesConfirmationModal-module__animateUploadProgressBarWidth--qpRWF";
var _2 = "SectionChangesConfirmationModal-module__animatedBackground--jlUrY";
var _3 = "SectionChangesConfirmationModal-module__container--snVai";
var _4 = "SectionChangesConfirmationModal-module__footer--whIuc";
var _5 = "SectionChangesConfirmationModal-module__message--qGEj_";
var _6 = "SectionChangesConfirmationModal-module__sectionName--Jk0bt";
var _7 = "SectionChangesConfirmationModal-module__sectionRow--Mt4Mr";
var _8 = "SectionChangesConfirmationModal-module__sectionRowContainer--Rke_U";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "footer", _5 as "message", _6 as "sectionName", _7 as "sectionRow", _8 as "sectionRowContainer" }
